// semeia-disable-reexport
export function deepEqual(object1?: object, object2?: object) {
  if (!object1 || !object2) {
    return false;
  }
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const isObjectPair = isObject(val1) && isObject(val2);
    if (
      (isObjectPair && !deepEqual(val1, val2)) ||
      (!isObjectPair && val1 !== val2)
    ) {
      return false;
    }
  }
  return true;
}
function isObject(object: object) {
  return object != null && typeof object === "object";
}
